import { render, staticRenderFns } from "./Portafolio.vue?vue&type=template&id=67e4bdfe&scoped=true"
import script from "./Portafolio.vue?vue&type=script&lang=js"
export * from "./Portafolio.vue?vue&type=script&lang=js"
import style0 from "./Portafolio.vue?vue&type=style&index=0&id=67e4bdfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4bdfe",
  null
  
)

export default component.exports